import { Box, Button, Modal, Text, useMantineTheme } from "@mantine/core";
import { AlertCircle, CircleCheck, CircleX } from "tabler-icons-react";

import React from "react";

import { themeProvider } from "../style/utils";

import "./genericPopUp.css";
import { closePopup } from "../../stateManagement/actions/popupActions";
import { useSelector } from "react-redux";
import store from "../../stateManagement/store";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";

export function DashboardPopup() {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const theme = useMantineTheme();
  const popupState = useSelector(() => store.getState().popupState)
  const closeModal = () => {
    closePopup()
    if(popupState.callBack) popupState.callBack();
  };

  return (
    <div>
      <Modal
        withCloseButton={false}
        zIndex={100000}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        style={{ marginTop: "14rem" }}
        overlayOpacity={0.55}
        overlayBlur={3}
        opened={popupState.isOpen}
        onClose={closeModal}
        radius="md"
        size="500px"
        className="genericPopUp-modalContainer"
      >
        <div className="genericPopUp-container">
          <Box>
            <Box
              sx={() => ({
                display: "flex",
                justifyContent: "center",
              })}
            >
              {popupState.type === "Success" && (
                <CircleCheck size={56} strokeWidth={2} color="#1c7ea0" />
              )}
              {popupState.type === "Alert" && (
                <AlertCircle size={56} strokeWidth={2} color="#1c7ea0" />
              )}
              {popupState.type === "Error" && (
                <CircleX size={56} strokeWidth={2} color="#1c7ea0" />
              )}
            </Box>

            <Text
              size="xl"
              align="center"
              sx={() => ({
                width: "100%",
                justifyContent: "center",
                marginBottom: "6%",
                marginTop: "6%",
                fontSize: "16px",
                paddingLeft: "3rem",
                paddingRight: "3rem",
              })}
            >
               {translate(TranslationEnum.common_portal,popupState.message)}
            </Text>
            <Box>
              <Box className="genericPopUp-button">
                <Button
                  radius="xl"
                  size="md"
                  sx={themeProvider}
                  onClick={closeModal}
                  style={{
                    width: "100%",
                    backgroundColor: "#1c7ea0",
                    fontSize: "11px",
                  }}
                >
                  {" "}
                  {translate(TranslationEnum.common_portal,"CONTINUE")}
                </Button>
              </Box>
            </Box>
          </Box>
        </div>
      </Modal>
    </div>
  );
}
